import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[sanitizeChars]',
})
export class SanitizeCharsDirective {
    /** es: /[^a-zA-Z0-9]/g  oppure  /[$#]/g  */
    readonly disallowed = input<RegExp | null>(null, { alias: 'sanitizeChars' });

    private readonly el = inject<ElementRef<HTMLInputElement>>(ElementRef);
    private readonly ngControl = inject(NgControl);

    private sanitizing = false;

    @HostListener('input')
    onInput() {
        this.sanitizeFromElement();
    }

    @HostListener('paste', ['$event'])
    onPaste(e: ClipboardEvent) {
        const regex = this.disallowed();
        if (!regex) return;

        // intercetta il testo incollato e puliscilo prima che entri
        const text = e.clipboardData?.getData('text') ?? '';
        const cleaned = text.replace(regex, '');

        if (cleaned === text) return; // nulla da fare

        e.preventDefault();

        const inputEl = this.el.nativeElement;
        const start = inputEl.selectionStart ?? inputEl.value.length;
        const end = inputEl.selectionEnd ?? inputEl.value.length;

        const next = inputEl.value.slice(0, start) + cleaned + inputEl.value.slice(end);

        this.sanitizing = true;
        inputEl.value = next;

        // riposiziona caret dopo il testo incollato
        const caret = start + cleaned.length;
        queueMicrotask(() => {
            inputEl.setSelectionRange(caret, caret);
            this.sanitizing = false;
        });

        this.setControlValue(next);
    }

    private sanitizeFromElement() {
        if (this.sanitizing) return;

        const inputEl = this.el.nativeElement;
        const raw = inputEl.value ?? '';
        const regex = this.disallowed();
        if (!regex) return;

        const start = inputEl.selectionStart ?? raw.length;

        // conta quante rimozioni avvengono PRIMA del caret
        const beforeCaret = raw.slice(0, start);
        const removedBefore = beforeCaret.length - beforeCaret.replace(regex, '').length;

        const cleaned = raw.replace(regex, '');
        if (cleaned === raw) return;

        this.sanitizing = true;
        inputEl.value = cleaned;

        queueMicrotask(() => {
            const newPos = Math.max(0, start - removedBefore);
            inputEl.setSelectionRange(newPos, newPos);
            this.sanitizing = false;
        });

        this.setControlValue(cleaned);
    }

    private setControlValue(v: string) {
        const ctrl = this.ngControl.control;
        if (!ctrl) return;

        // in genere è meglio far partire gli eventi;
        // se temi loop, usa il flag (sanitizing) come sopra
        ctrl.setValue(v, { emitEvent: true });
        ctrl.markAsDirty();
    }
}
